package com.shadowings.gero.presentation.component

import androidx.compose.material3.AlertDialog
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.material3.TimePicker
import androidx.compose.material3.rememberTimePickerState
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.semantics.semantics
import androidx.compose.ui.semantics.testTag
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.cancel
import gero.composeapp.generated.resources.conferma_btn
import org.jetbrains.compose.resources.stringResource

@OptIn(ExperimentalMaterial3Api::class)
@Composable
actual fun NativeTimePickerDialog(
    hour: Int,
    minute: Int,
    onTimePicked: (hour: Int, minute: Int) -> Unit,
    onDismiss: () -> Unit,
) {
    val state = rememberTimePickerState(
        initialHour = hour.coerceIn(0, 23),
        initialMinute = minute.coerceIn(0, 59),
        is24Hour = true
    )

    AlertDialog(
        onDismissRequest = onDismiss,
        confirmButton = {
            TextButton(
                onClick = { onTimePicked(state.hour, state.minute) },
                modifier = Modifier.semantics { testTag = "web_time_picker_btn_confirm" }
            ) {
                Text(stringResource(Res.string.conferma_btn))
            }
        },
        dismissButton = {
            TextButton(
                onClick = onDismiss,
                modifier = Modifier.semantics { testTag = "web_time_picker_btn_cancel" }
            ) {
                Text(stringResource(Res.string.cancel))
            }
        },
        title = null,
        text = { TimePicker(state = state) }
    )
}
